import { useState } from 'react';
import { Input } from '../ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { FREQUENCY, fyEndFor, fyLabel, fyOfKey, periodFromKey, periodOptions, yearWindow } from '../../lib/taxPeriods';

const OTHER = '__other__';

// FY start year input for "Other" (e.g. 2019 → FY2019-20).
const OtherYear = ({ onPick, label, testId }) => {
  const [y, setY] = useState('');
  const commit = (v) => { const n = Number(v); if (n >= 1990 && n <= 2099) onPick(n + 1); };
  return <Input type="number" className="h-9 w-32" placeholder={label} value={y} onChange={(e) => { setY(e.target.value); commit(e.target.value); }} data-testid={testId} />;
};

// Reporting period selector driven by the template's period type (Annual / Quarterly / Monthly / FBT year).
export const PeriodPicker = ({ periodType, value, onChange }) => {
  const [otherFy, setOtherFy] = useState(false);
  const cur = fyEndFor();
  const selFy = fyOfKey(value) || cur;
  const freq = <span className="text-[11px] font-medium px-2 py-0.5 rounded-full bg-primary/10 text-primary" data-testid="period-frequency">{FREQUENCY[periodType]}</span>;

  if (periodType === 'financial_year' || periodType === 'fbt_year') {
    const opts = periodOptions(periodType);
    const inList = opts.some((o) => o.key === value);
    const isFbt = periodType === 'fbt_year';
    return (
      <div className="flex flex-wrap items-center gap-2">
        {freq}
        <Select value={inList && !otherFy ? value : OTHER} onValueChange={(v) => { if (v === OTHER) setOtherFy(true); else { setOtherFy(false); onChange(v); } }}>
          <SelectTrigger className="h-9 w-64" data-testid="period-select"><SelectValue placeholder="Select period" /></SelectTrigger>
          <SelectContent>
            {opts.map((o) => <SelectItem key={o.key} value={o.key}>{o.label}</SelectItem>)}
            <SelectItem value={OTHER}>Other…</SelectItem>
          </SelectContent>
        </Select>
        {(otherFy || !inList) && <OtherYear label={isFbt ? 'Year ending' : 'FY start year'} testId="period-other-year"
          onPick={(endFromStart) => onChange(isFbt ? `fbt:${endFromStart - 1}` : `fy:${endFromStart}`)} />}
        {value && !inList && <span className="text-xs text-muted-foreground" data-testid="period-other-label">{periodFromKey(value)?.label}</span>}
      </div>
    );
  }
  const years = yearWindow(cur);
  const inYears = years.includes(selFy);
  const opts = periodOptions(periodType, selFy);
  const setFy = (fy) => { const idx = Math.max(0, opts.findIndex((o) => o.key === value)); onChange(periodOptions(periodType, fy)[idx].key); };
  return (
    <div className="flex flex-wrap items-center gap-2">
      {freq}
      <Select value={inYears && !otherFy ? String(selFy) : OTHER} onValueChange={(v) => { if (v === OTHER) setOtherFy(true); else { setOtherFy(false); setFy(Number(v)); } }}>
        <SelectTrigger className="h-9 w-36" data-testid="period-fy-select"><SelectValue /></SelectTrigger>
        <SelectContent>{years.map((y) => <SelectItem key={y} value={String(y)}>{fyLabel(y)}</SelectItem>)}<SelectItem value={OTHER}>Other…</SelectItem></SelectContent>
      </Select>
      {(otherFy || !inYears) && <OtherYear label="FY start year" testId="period-other-year" onPick={setFy} />}
      <Select value={value || ''} onValueChange={onChange}>
        <SelectTrigger className="h-9 w-44" data-testid="period-select"><SelectValue placeholder="Select period" /></SelectTrigger>
        <SelectContent>{opts.map((o) => <SelectItem key={o.key} value={o.key}>{o.label}</SelectItem>)}</SelectContent>
      </Select>
    </div>
  );
};
